import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { news } from '@/mocks/news';

export default function LatestNews() {
  const latest = news.slice(0, 5);

  return (
    <section className="mx-auto max-w-6xl px-4 md:px-6">
      <SectionHeading
        title="最新影视资讯"
        subtitle="行业动态、剧情解析与作品评论"
        moreText="更多资讯"
        moreTo="/news"
      />
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {latest.map((item, i) => (
          <Link
            key={item.id}
            to={`/news/detail/${item.id}`}
            className={`group flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-500 ${
              i === 0 ? 'lg:col-span-2' : ''
            }`}
          >
            <div
              className={`shrink-0 overflow-hidden rounded-md ${i === 0 ? 'h-28 w-40 md:h-36 md:w-56' : 'h-20 w-28'}`}
            >
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title}资讯配图`}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex min-w-0 flex-1 flex-col">
              <div className="mb-2 flex items-center gap-2">
                <span className="rounded bg-accent-500/15 px-2 py-0.5 text-xs font-medium text-accent-400">
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-500">{item.date}</span>
              </div>
              <h3 className={`font-heading font-semibold text-foreground-950 ${i === 0 ? 'text-lg md:text-xl' : 'text-sm'}`}>
                <span className="line-clamp-2">{item.title}</span>
              </h3>
              <p className={`mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600 ${i === 0 ? '' : 'hidden sm:block'}`}>
                {item.summary}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}